<template>
  <div class="hello">
    <h3>{{instruction}}</h3>
  </div>
</template>

<script>
import db from '../../../lib/db'
export default {
  name: 'QuestionInstruction',
  props: {
    qtype: String
  },
    data () {
        return {
            instruction: ''  
        }
    },
    methods: {
        getInstruction: function () {
            console.log('qustion type ', this.qtype)
            return db.getRef().ref('language/instructions/').child(this.qtype).once('value').then((snapshot) => {
                console.log('instruction ', snapshot.val())
                this.instruction = snapshot.val()
                return snapshot.val()
            })
        }
    },
    created () {
        this.getInstruction()
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
